import { loadScript } from '@day1co/browser-util';

export class GtmTracker {
  static create(opts, context) {
    return new GtmTracker(opts, context);
  }

  constructor({ id }, context) {
    this.id = id;
    this.name = 'gtm';

    context.dataLayer = context.dataLayer || [];
    context.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    loadScript(`//www.googletagmanager.com/gtm.js?id=${this.id}`)
      .then(() => {})
      .catch((err) => console.error('install err!', err));
  }

  track(event, data) {}
}
